import type { PickActions } from '@core/ngrx-legacy';
import { createEntityCollectionStore, getEntityCollectionActions } from '@core/ngrx-legacy';
import type { PipelineTemplateListItem } from '@core/pipeline-templates-types';

export const jobTemplateScope = (id: number) => `job-template:${id}`;
const idSelector = ({ id }: { id: number }) => id;
const { actions, reducer } = createEntityCollectionStore<PipelineTemplateListItem>()(
  'PipelineTemplateJobTemplateListItem',
  {
    idSelector,
    customActions: adapter => {
      const defaultActions = getEntityCollectionActions(adapter, idSelector);
      return {
        fetchCollection: (state, payload: { jobTemplateId: number }) =>
          defaultActions.fetchCollection(state, {
            scope: jobTemplateScope(payload.jobTemplateId),
          }),
      };
    },
  },
);

const PipelineTemplateJobTemplateListItemActions: PickActions<typeof actions, 'fetchCollection'> =
  actions;

export {
  PipelineTemplateJobTemplateListItemActions,
  reducer as PipelineTemplateJobTemplateListItemReducer,
};
